import { Box, Button, Checkbox, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { getMyDraftCampaigns } from "../../pages/company-wishlist/action";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { visuallyHidden } from "@mui/utils";
import microPhoneDraftCampaign from '../../assets/images/icons/microPhoneDraftCampaign.svg'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '1314px',
    maxWidth: '1400px !important',
    height: '486px',
    padding: '0px',
    BorderRadius: '16px',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function EnhancedTableHead(props) {
  const { order, orderBy } = props;

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Name",
      type: "",
    },
    {
      id: "brand",
      numeric: false,
      disablePadding: true,
      label: "Brand",
      type: "",
    },
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: "Type",
      type: "",
    },
    {
      id: "publishDuration",
      numeric: false,
      disablePadding: true,
      label: "Duration",
      type: "",
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      label: "Product Name",
      type: "",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      type: "",
    },
  ];

  return (
    <TableHead className="hideActionSort">
      <TableRow sx={{ background: '#DBECFF !important', height: "50px", "& th": { backgroundColor: "inherit !important" }, }}>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}>
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

const CampaignListingModal = (props) => {
  const { open, setOpen, handleAddInfluncersToCampaignsFromCurrentList, handleOpenCreateCampaignModal } = props;
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const { draftCampaigns } = useSelector(state => state.wishlistSlice);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getMyDraftCampaigns());
  }, [])


  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <Stack direction={"row"} gap={{ xs: 2, sm: 0 }} flexWrap="wrap" justifyContent="space-between" alignItems="center" sx={{ width: '100%', padding: '16px 24px' }}>
        <Typography sx={{ fontWeight: 500, fontSize: { xs: "14px", sm: '18px' }, color: '#181D27' }}>Select Campaign</Typography>
        <Box>
          <Button
            onClick={() => { handleOpenCreateCampaignModal(selectedCampaign) }}
            sx={{ "&.Mui-disabled": { background: 'var(--draft)', "& p": { background: 'var(--draft)', color: 'white' } }, background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: '10px', margin: '0 20px 0 0' }}><Typography sx={{ color: '#000', margin: '2px', borderRadius: '9px', padding: { xs: '10px', sm: '10px 20px' }, width: '100%', height: '100%', fontSize: { xs: "12px", sm: "16px" }, background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, "&:hover": { background: 'transparent', color: 'white' } }}>{!selectedCampaign ? "Create Campaign" : "Update Campaign"}
            </Typography></Button>
          <Button
            onClick={() => handleAddInfluncersToCampaignsFromCurrentList(selectedCampaign)}
            disabled={!selectedCampaign} sx={{ background: !selectedCampaign ? 'var(--draft)' : 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: '10px', margin: '0px' }}><Typography sx={{ color: 'white', margin: '2px', borderRadius: '9px', padding: { xs: '10px', sm: '10px 20px' }, width: '100%', height: '100%', fontSize: { xs: "12px", sm: "16px" }, background: !selectedCampaign ? 'var(--draft)' : 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, "&:hover": { background: 'transparent', color: 'white' } }}>Add List to Campaign
            </Typography></Button>
        </Box>
      </Stack>
      <hr />
      {(draftCampaigns && draftCampaigns?.length) ? <Box sx={{
        height: '90%', border: '0px solid red', overflowY: 'scroll', overflowX: 'hidden', scrollbarWidth: 'none', // For Firefox
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}>
        <TableContainer sx={{ height: '100%' }}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              onRequestSort={() => { }}
              numSelected={0}
              onSelectAllClick={function () {
                throw new Error("Function not implemented.");
              }} />
            <TableBody>
              {(
                draftCampaigns?.map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row?.id}
                      className={"tableRow"}
                      sx={{
                        "&:hover": {
                          backgroundColor: '#F0F7FF !important', "& td": {
                            backgroundColor: "inherit !important"
                          },
                        }, height: '60px'
                      }}>
                      <TableCell component="td" scope="row" padding="none">
                        <Stack direction={"row"} spacing={2}>
                          <div class="MuiAvatar-root MuiAvatar-circular css-1nn861f-MuiAvatar-root" style={{ display: 'flex', border: '0px solid red', width: 'fit-content', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                            <Checkbox
                              checked={selectedCampaign === row.id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedCampaign(row.id)
                                } else {
                                  setSelectedCampaign(null)
                                }
                              }}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                            <img alt="" style={{ height: '35px', width: '35px', borderRadius: "100px" }} src={row.picture ? row.picture : "/profile.jpg"} className="MuiAvatar-img" />
                          </div>
                          <Link className="text-decoration-none" style={{ fontSize: '14px', fontWeight: '500', letterSpacing: '0px' }} onClick={(e) => {
                            e.preventDefault();
                            navigate(`/campaign/partial/details/${row.id}`, { state: row });
                          }} >{row?.name || "N/A"}</Link>
                        </Stack>
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none" sx={{ textTransform: "uppercase" }}>
                        {row?.brandName || "N/A"}
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none" className='capitalize-first-letter'>
                        {row?.type || "N/A"}
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none">
                        {moment(row?.startDate).format("DD MMM")}{" - "}{moment(row?.endDate).format("DD MMM")}
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none">
                        {row?.products?.map((v) => v.name)?.toString() || "N/A"}
                      </TableCell>
                      <TableCell align="left">
                        <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                      </TableCell>
                    </TableRow >
                  );
                })
              )}
            </TableBody >
          </Table >
        </TableContainer >
      </Box> : <Stack sx={{ height: '100%', width: '100%' }} justifyContent="center" alignItems="center">

        <img src={microPhoneDraftCampaign} alt="microPhoneDraftCampaign" style={{ height: '116px', width: '116px' }} />
        <Typography sx={{ fontSize: '16px', fontWeight: 400, color: '#726C6C', paddingTop: '24px' }}>No draft campaign yet? Get started by creating one now.</Typography>
      </Stack>}
    </BootstrapDialog>
  )
}

export default CampaignListingModal